
import { transformObjectKeys } from "@core/utility/common-utils"
import { GoogleDriveAPIBase } from "@core/utility/specific-utils/classes-utils"
import { RecursiveSnakeCaseType, transformFromCamelCaseToSnakeCase, transformFromSnakeCaseToCamelCase } from "@core/utility/string-utils"
import { WMLConstructorDecorator } from "@windmillcode/wml-components-base"
import { Observable, of, take } from "rxjs"

export let exportUsersLoad = (uiBody:ExportUsersUIRequestBody): Observable<ExportUsersAPIRequestBody>=>{

  let apiBody = new ExportUsersAPIRequestBody({data:transformObjectKeys(
    uiBody,
    transformFromCamelCaseToSnakeCase
  )})
  return of(apiBody)
  .pipe(
    take(1),
  )
}

export let exportUsersSuccess = (apiBody:ExportUsersAPIResponseBody):ExportUsersUIResponseBody=>{
  let uiBody = new ExportUsersUIResponseBody(transformObjectKeys(
    apiBody.data,
    transformFromSnakeCaseToCamelCase
  ))
  return uiBody
}
@WMLConstructorDecorator
export class ExportUsersUIRequestBody extends GoogleDriveAPIBase {
  constructor(props:Partial<ExportUsersUIRequestBody>={}){ super()}

}

export class ExportUsersAPIRequestBody {
  constructor(props:Partial<ExportUsersAPIRequestBody>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )
  }
  data:RecursiveSnakeCaseType<ExportUsersUIRequestBody>
}

export class ExportUsersUIResponseBody {
  constructor(props:Partial<ExportUsersUIResponseBody>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )
  }
  name:string
  content:string
}

export class ExportUsersAPIResponseBody {
  constructor(props:Partial<ExportUsersAPIResponseBody>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )
  }
  data:RecursiveSnakeCaseType<ExportUsersUIResponseBody>
}

